import classNames from 'classnames'
import { useMemo, CSSProperties } from 'react'
import { deriveAccessibleColors, LineWeight, Spacing } from '@opallabs/gem'
import * as tokenStyles from '../styles'
import { cssTokenVariables } from '../styles'
import { ColorTokenProps, DEFAULT_COLOR } from '../types'
import * as styles from './styles'

export const ColorDotToken: React.VFC<ColorTokenProps> = ({
  color = DEFAULT_COLOR,
  className,
  ...props
}) => {
  const { background, foreground, border, hoverBorder } = useMemo(
    () => deriveAccessibleColors(color),
    [color]
  )

  return (
    <span
      aria-hidden
      className={classNames(tokenStyles.selectors.dotToken, className)}
      css={styles.dotToken}
      style={
        {
          [cssTokenVariables.colorBackground]: background,
          [cssTokenVariables.colorForeground]: foreground,
          [cssTokenVariables.tokenSize]: `${Spacing.XS * 3}px`,
          [cssTokenVariables.tokenBorder]: `${LineWeight.Small}px solid ${border}`,
          [cssTokenVariables.tokenHoverBorder]: `${LineWeight.Small}px solid ${hoverBorder}`,
        } as CSSProperties
      }
      {...props}
    />
  )
}
ColorDotToken.displayName = 'Lapidary: ColorDotToken'
